"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchGetProductById = exports.fetchCategoriesImages = exports.fetchProducts = exports.fetchCategories = exports.fetchUserData = void 0;
async function fetchUserData() {
    try {
        const response = await fetch('/api/user_auth');
        return await response.json();
    }
    catch (error) {
        console.error('Error:', error);
    }
}
exports.fetchUserData = fetchUserData;
async function fetchCategories() {
    try {
        const response = await fetch('/api/divise/get-categories');
        return await response.json();
    }
    catch (error) {
        console.error('Error:', error);
    }
}
exports.fetchCategories = fetchCategories;
async function fetchProducts(data) {
    try {
        let response;
        if (data === null || data === void 0 ? void 0 : data.category) {
            response = await fetch(`/api/divise/get-articles?category=${data.category}`);
        }
        else {
            response = await fetch('/api/divise/get-articles');
        }
        const res = response;
        if (!res.ok) {
            throw new Error(`${res.status}`);
        }
        const result = await res.json();
        if (!result.data || !Array.isArray(Object.values(result.data))) {
            throw new Error("Invalid data format received");
        }
        return Object.values(result.data);
    }
    catch (error) {
        console.log('Error:', error);
        throw new Error(`${error}`); // Restituisce un array vuoto in caso di errore
    }
}
exports.fetchProducts = fetchProducts;
async function fetchCategoriesImages() {
    try {
        const response = await fetch('/api/divise/get-categories-images');
        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const res = await response.json();
        return Object.values(res.data);
    }
    catch (error) {
        console.error('Error fetching category images:', error);
        return []; // Assicura sempre un valore di ritorno
    }
}
exports.fetchCategoriesImages = fetchCategoriesImages;
async function fetchGetProductById(id) {
    try {
        const response = await fetch(`/api/divise/get-article-by-id?id=${id}`);
        const res = await response.json();
        return res.data[0];
    }
    catch (error) {
        console.error('Error:', error);
    }
}
exports.fetchGetProductById = fetchGetProductById;
